<template>
    <v-dialog
        v-if="splitDialog"
        v-model="splitDialog"
        persistent
        width="600px"
    >
        <v-form ref="splitForm">
            <v-card>
                <v-card-title class="primary white--text">
                    <v-icon dark class="mr-2">call_split</v-icon>Split Task
                </v-card-title>

                <v-card-text class="pb-0">
                    <v-toolbar class="py-2" outlined flat>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-toolbar-title
                                    class="title pr-2"
                                    v-on="on"
                                >
                                    {{
                                        growthTask
                                            ? growthTask.plant.name
                                            : ""
                                    }}
                                    <div
                                        class="
                                            mt-n1
                                            grey--text
                                            text--darken-1
                                            caption
                                        "
                                        v-if="growthTask"
                                    >
                                        {{
                                            (growthTask
                                                ? growthTask.growthStartDate
                                                : "1970-01-01")
                                                | moment("YYYY-[W]WW")
                                        }}
                                    </div>
                                </v-toolbar-title>
                            </template>
                            <span>{{
                                growthTask ? growthTask.plant.name : ""
                            }}</span>
                        </v-tooltip>

                        <v-spacer />
                        <v-icon :color="taskColor" class="mr-1">eco</v-icon>
                        <span :class="taskColor + `--text headline`">{{
                            growthTask ? growthTask.totalInventory : 0
                        }}</span>
                    </v-toolbar>

                    <!-- split quantity -->
                    <v-row class="mx-0 mt-5">
                        <v-col cols="12">
                            <v-text-field
                                v-model="splitingTaskData.splitQuantity"
                                :rules="[
                                    rules.required,
                                    rules.maxNumber(
                                        growthTask
                                            ? growthTask.totalInventory - 1
                                            : 1
                                    )
                                ]"
                                min="1"
                                type="number"
                                label="Split Quantity *"
                                outlined
                                class="subtitle-2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <!-- split reasons -->
                            <v-autocomplete
                                v-model="
                                    splitingTaskData.inventoryChangeReasonTag_Id
                                "
                                :items="splitReasons"
                                item-text="node.tag"
                                item-value="node.id"
                                :loading="queryLoading"
                                label="Split Reason"
                                class="subtitle-2"
                                outlined
                            >
                                <template
                                    v-if="
                                        hasPermission(
                                            'add_inventorychangereasontag'
                                        )
                                    "
                                    v-slot:append-outer
                                >
                                    <v-btn text small tabindex="-1">
                                        <v-icon
                                            color="grey"
                                            @click="
                                                $emit('addSplitReasonTag')
                                            "
                                            tabindex="-1"
                                            >add</v-icon
                                        >
                                    </v-btn>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="mr-5 pb-5">
                    <v-spacer></v-spacer>
                    <v-btn text rounded @click="$emit('closeWindow')"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :disabled="!hasPermission('change_growthtask')"
                        outlined
                        rounded
                        color="primary"
                        :loading="isSaving"
                        @click="validateSplitTaskForm"
                        >Split</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
import helper from "@/utils/helper.js";
export default {
    name : "SplitGrowthTaskDialog",
    props : ["splitDialog","growthTask", "isSaving", "taskColor", "rules" , "splitingTaskData", "splitReasons", "queryLoading"],
    data(){
        return {

        }
    },
    methods : {
        validateSplitTaskForm(){
            this.$emit('validatingSplitForm', this.$refs.splitForm.validate())
        }
    },
    created() {
        this.hasPermission = helper.hasPermission;
    },
}
</script>